<template>
  <div class="latestEntry">
    <div class="d-flex w-100 justify-content-between">
      <h5 class="mb-1">{{title}}</h5>
      <small><font-awesome-icon :icon="['far', 'clock']"/> {{displayDate}}</small>
    </div>
    <p class="mb-1 text-left indent">
      {{summary}}
    </p>
  </div>
</template>

<script>
export default {
  name: 'latestEntry',
  props: {
    title: String,
    summary: String,
    displayDate: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.latestEntry:hover {
  color: #43a5d2;
}

</style>



// WEBPACK FOOTER //
// src/components/LatestEntry.vue